"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sodium = require("libsodium-wrappers-sumo");
var MemoryUtil = {
    zeroize: function (object) {
        var _this = this;
        if (object instanceof Uint8Array) {
            sodium.memzero(object);
        }
        else if (object instanceof ArrayBuffer) {
            sodium.memzero(new Uint8Array(object));
        }
        else if (typeof object === 'object') {
            Object.keys(object)
                .map(function (key) { return object[key]; })
                .forEach(function (val) { return _this.zeroize(val); });
        }
        else {
            return;
        }
    },
};
exports.default = MemoryUtil;



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/util/MemoryUtil.js
// module id = 31
// module chunks = 0 1